export const graphColors = [
  { color: "#4FC26B", bg: "#ECFEF5" },
  { color: "#AC61FF", bg: "#F1E7FC" },
  { color: "#E49A38", bg: "#FEF9EC" },
  { color: "#349AC6", bg: "#EBFCFF" },
  { color: "#D25046", bg: "#FFECEB" },
];
